import styled from 'styled-components';
import { motion } from 'framer-motion';

export const StyledErrorWrapper = styled(motion.div)`
    position: absolute;
    top: 0;
    left: 0;
`;
